import { AccessoryIcon } from "./AccessoryIcon";
import { Accessories } from "../../config/Config";
import { Object3D } from "three";
import { ISignalP1 } from "../../utils/signal/ISignalP1";
import { Signal } from "../../utils/signal/Signal";
import { AccessoryPlacer } from "./AccessoryPlacer";
import { Accessory } from "./Accessory";
import { SimpleSignal } from "../../utils/SimpleSignal";
import { Collection } from "../../utils/Collection";
import { IAccessorySetting } from "../../config/IProjectSettings";

interface IAccessoryViewConfig
{
	accessoryConfig: {
		id:string;
		modelPath:string
		rotation:number[];
		position:number[]
	}[];
	accessories: Accessories;
	scene: Object3D;
}

/**
 * Container for accessories like truck, person
 */
export class AccessoryView
{
	public moveIconClickSignal: ISignalP1<AccessoryIcon>;
	private _icons : AccessoryIcon[];
	private _iconsById: {
		[id: string]: AccessoryIcon;
	};

	private _accessories: Accessories;

	constructor(config: IAccessoryViewConfig)
	{
		this.moveIconClickSignal = new Signal();
		var accessoryPlacer = new AccessoryPlacer();

		this._icons = [];
		this._iconsById = {};

		// init config

		var accessory_configs = config.accessoryConfig;
		for (var i = 0, ln = accessory_configs.length; i < ln; ++i)
		{
			var config_i = accessory_configs[i];
			var accessory = new Accessory({
				originalConfig: config_i,
				scene: config.scene,
				placer: accessoryPlacer
			});
			var icon = new AccessoryIcon(config_i.id, accessory, this.moveIconClickSignal);
			this._icons.push(icon);
			this._iconsById[config_i.id] = icon;
		}

		// init Accessories

		this._accessories = config.accessories || {
			accessories: [],
			change: new SimpleSignal()
		};
		this._accessories.change.add(this.onAccessoryChange);
	}

	// loading
	private onAccessoryChange = () =>
	{
		var accessorySettings = this._accessories.accessories || [];
		var accessorySettingsCollection = new Collection(accessorySettings, "id");

		for (var i = 0; i < this._icons.length; ++i)
		{
			var icon = this._icons[i];
			var settings = accessorySettingsCollection.getByKey(icon.id);
			if (!settings)
			{
				icon.resetSettings();
			}
			else
			{
				icon.setSetting(settings);
			}
		}
	}

	// saving
	public getAccessoriesForSave(): IAccessorySetting[]
	{
		var settings = [];

		for (var i = 0; i < this._icons.length; ++i)
		{
			var setting = this._icons[i].getSetting();
			settings.push(setting);
		}

		return settings;
	}

	public get icons()
	{
		return this._icons;
	}
}